@import '../Field/field.css';
@import '../es-input/es-input.css';

/**
 * @prop --field-grid-columns: The field layout.
 **/

:host {
    display: block;
}

es-input:not(:first-of-type)::part(label) {
    visibility: hidden;
}

.row {
    display: grid;
    grid-template-columns: var(--field-grid-columns);
    column-gap: var(--field-grid-gap);
    align-items: center;
}

.delete_row {
    width: fit-content;
    --border-radius: 50%;
}

.add_item {
    grid-column: input;
    justify-self: end;
    --text-color: var(--color-text);
    --border-radius: 20px;
}
